import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';
import { VOD_ENDPOINT } from '../constants';

export const useUploadMediaFile = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const uploadMediaFile = async (mediaFile, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.post(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}${VOD_ENDPOINT}upload`,
        { media_file: mediaFile }
      );

      if (response?.data && response?.data['success']) {
        setSuccess(true);
        handleUpdate(true, response?.data['payload']);
      } else {
        throw new Error('File upload Response Error !!!')
      }
    } catch (error) {
      setError("An error occurred while uploading the media file " + error);
      handleUpdate(false, error);
    } finally {
      setLoading(false);
    }
  };

  return [ uploadMediaFile, loading, error, success ];
};